// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cursorPointer[data-v-14803afc]{cursor:pointer!important}.height_73[data-v-14803afc]{height:73px!important}.ps_rel_100[data-v-14803afc]{position:relative;left:50%!important}.marg_left_22[data-v-14803afc]{margin-left:22px!important}", ""]);
// Exports
module.exports = exports;
